interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="px-16 py-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/334fade3-57b3-4b80-920d-a037c9305611.png" 
              alt="SEMBODJA OOD Logo" 
              className="h-10 w-10 object-contain"
            />
            <h1 className="text-lg font-bold text-[#2A2A2A]" style={{ fontFamily: 'Inter, sans-serif' }}>
              SEMBODJA OOD
            </h1>
          </div>
          <ul className="flex items-center gap-10">
            {['Home', 'About', 'Products', 'Features', 'Contact'].map((item) => (
              <li key={item}>
                <button
                  onClick={() => scrollToSection(item.toLowerCase())}
                  className="text-sm font-medium text-[#2A2A2A] hover:text-[#1A3A3A] transition-colors relative group whitespace-nowrap cursor-pointer"
                >
                  {item}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#1A3A3A] transition-all duration-300 group-hover:w-full"></span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
